import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PendingOrder } from './model/pending-order.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { RootService } from 'src/app/services/root/root.service';

@Component({
  selector: 'app-pending-orders',
  templateUrl: './pending-orders.component.html',
  styleUrls: ['./pending-orders.component.scss']
})

export class PendingOrdersComponent implements OnInit {
  displayedColumns: string[];
  dataSource = new MatTableDataSource<PendingOrder>();
  data: any;
  client;

  constructor(
    private _spinner: NgxSpinnerService,
    private rootservice: RootService) { }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {

    this._spinner.show();

    this.client = JSON.parse(sessionStorage.getItem("session"));

    this.displayedColumns = this.client.dsSesion.ttsesion[0].tipo.toLowerCase() == 'vendedor' ? ['nombreCliente', 'codigoCliente', 'codigoArticulo', 'nombreArticulo', 'fecha', 'cantidad', 'estado'] : ['codigoArticulo', 'nombreArticulo', 'fecha', 'cantidad', 'estado'];

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.rootservice.pending().subscribe(data => {
      this.dataSource.data = data["pendientes"];
      this._spinner.hide();
    });

  }

  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
